import { IMAGES } from "../data/site";

export const About = () => {
  return (
    <section data-testid="about-section" className="py-16 bg-ink text-bone">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-6">
          <div className="aspect-[16/10] rounded-xl overflow-hidden border border-white/10">
            <img
              src={IMAGES.interior}
              alt="Interno accogliente della boutique con capi selezionati"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="md:col-span-6 space-y-4">
          <p className="text-xs uppercase tracking-[0.18em] text-caramel font-semibold">
            Anni di Esperienza &amp; Cuore
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-normal">
            Il calore di un consiglio tra amiche
          </h2>
          <p className="text-sm text-bone/80 leading-relaxed">
            Nel nostro negozio fisico ti accogliamo col sorriso, ma se sei lontana ti
            seguiamo con la stessa cura su WhatsApp con foto, video e consigli su misura.
          </p>
        </div>
      </div>
    </section>
  );
};
